import BetModel from "../../../core/src/model/BetModel";
import GameModel from "../../../core/src/model/GameModel";
import ISavedSettings from "../../../src/model/ISavedSettings";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import SoundController from "../../../core/src/utils/SoundController";
import AutoplayModel from "../../../core/src/model/AutoplayModel";
import VendorModel from "../../model/VendorModel";
import SpinModel from "../../../core/src/model/SpinModel";
import Configs from "../../vendorConfigs/Configs";


export default class SaveSettingsRequest implements IRequestBuilder {
    get method() {
        return "POST";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/setsavedsettings";
    }
  
    get requestData() {
        return <{ g: string; sid: string; savedSettings: ISavedSettings }> {
            g: Configs.vendorServer.gameId,
            sid: GameModel.sessionID,
            savedSettings: {
                sound: {
                    effects: SoundController.isEffectsEnabled,
                    music: SoundController.isMusicEnabled
                },
                bet: {
                    currentBet: BetModel.coinSizeIndex
                },
                balance: {
                    ba: BetModel.balance
                },
                settingsPage: {
                    allowSkipIntroOn: VendorModel.allowSkipIntro,
                    spaceToSpinTurnOn: GameModel.spaceToSpin,
                    swipeReelsTurnOn: VendorModel.allowSwipeSpin,
                    fastPlayOn: GameModel.turboSpin
                },
                autoplay: {
                    spins: AutoplayModel.initialAutospinNum,
                    lossLimit: AutoplayModel.initialLossLimit,
                    winLimit: AutoplayModel.initialWinLimit,
                    totalWinLimit: AutoplayModel.initialTotalWinLimit,
                    stopOnAnyWin: AutoplayModel.initialStopOnAnyWin
                },
                freegames: {
                    expiredDuringFreeSpins: SpinModel.inFreegames() && SpinModel.isInFreespins() && VendorModel.hasFreeGamesExpiredDuringFreespins
                }
            }
        };
    }
}